import React from 'react'
import { FooterNewLP } from '@shared/components/footer'
import { PageLayout } from '@shared/components/page-layout'
import { PageLayoutOwnProps } from '@shared/components/page-layout/model'
import { Empty } from '@shared/models'
import { NextPageFC } from '@shared/models/next-fc'

import { mainBlock } from '../data/auto-loan'
import { NewLPScreen } from '../screens/new-lp'

const AutoLoanPage: NextPageFC<Empty, PageLayoutOwnProps> = () =>
	NewLPScreen({
		mainBlockPath: mainBlock,
		ratePoints: [
			'Пользуйтесь автомобилем',
			'ПТС остаётся у вас',
			'Для заявки только паспорт и СТС',
			'Низкая ставка от 9,5% годовых',
			'Без подтверждения дохода и поручителей',
			'Одобрение в день подачи заявки',
		],
		minLoan: 100000,
		maxLoan: 500000,
		minPeriod: 1,
		maxPeriod: 5,
		isAutoLoan: false,
		leadProductType: 'CAR_SECURED_LOAN',
		applicationFormTitle: 'Заявка на кредит',
		applicationFormProgressTitle: 'Вероятность одобрения кредита',
	})

AutoLoanPage.layout = PageLayout
AutoLoanPage.layoutProps = {
	menuProps: {
		hideLinksList: true,
	},
	customFooter: <FooterNewLP />,
}

AutoLoanPage.headProps = {
	title: 'Деньги на любые цели по честной ставке',
	description: 'От 100 тысяч рублей ► Конкурентная ставка ► Без скрытых комиссий и платежей',
	ogImageName: 'auto-loan.jpg',
}

export default AutoLoanPage
